var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.01562C6.25 5.66406 6.52344 5.39062 6.875 5.39062H12.5V1.71875C12.5 1.44531 12.8125 1.28906 13.0078 1.48438L18.5547 7.07031C18.7891 7.30469 18.7891 7.69531 18.5547 7.96875L13.0078 13.5547C12.8125 13.75 12.5 13.5938 12.5 13.3203V9.64844H6.875C6.52344 9.64844 6.25 9.375 6.25 9.02344V6.01562ZM5 6.01562V9.02344C5 10.0781 5.82031 10.8984 6.875 10.8984H11.25V13.3203C11.25 14.7266 12.9297 15.4297 13.9062 14.4141L19.4141 8.82812C20.1562 8.125 20.1562 6.91406 19.4141 6.17188L13.9062 0.585938C12.9297 -0.390625 11.25 0.3125 11.25 1.71875V4.14062H6.875C5.82031 4.14062 5 4.96094 5 6.01562ZM0 1.875V13.125C0 14.1797 0.820312 15 1.875 15H7.03125C7.26562 15 7.5 14.8047 7.5 14.5312V14.2188C7.5 13.9844 7.26562 13.75 7.03125 13.75H1.875C1.52344 13.75 1.25 13.4766 1.25 13.125V1.875C1.25 1.5625 1.52344 1.25 1.875 1.25H7.03125C7.26562 1.25 7.5 1.05469 7.5 0.78125V0.46875C7.5 0.234375 7.26562 0 7.03125 0H1.875C0.820312 0 0 0.859375 0 1.875Z",
    fill: "#666666"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.079608f6.svg";
export { ForwardRef as ReactComponent };